<template>
  <div></div>
<!--  <navbar-->
<!--    position="fixed"-->
<!--    type="info"-->
<!--    :transparent="transparent"-->
<!--    :color-on-scroll="colorOnScroll"-->
<!--    menu-classes="ml-auto"-->
<!--  >-->
<!--    <template slot="navbar-menu">-->
<!--      <li class="nav-item">-->
<!--        <a-->
<!--          class="nav-link"-->
<!--          href="/"-->
<!--        >-->
<!--          <i class="now-ui-icons shopping_shop"></i>-->
<!--          <p>Home</p>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="nav-item">-->
<!--        <a-->
<!--          class="nav-link"-->
<!--          rel="tooltip"-->
<!--          title="Like us on Facebook"-->
<!--          data-placement="bottom"-->
<!--        >-->
<!--          <i class="fab fa-facebook-square"></i>-->
<!--          <p class="d-lg-none d-xl-none">Facebook</p>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="nav-item">-->
<!--        <a-->
<!--          class="nav-link"-->
<!--          rel="https://www.instagram.com/therabbitholetea/"-->
<!--          title="Follow us on Instagram"-->
<!--          data-placement="bottom"-->
<!--        >-->
<!--          <i class="fab fa-instagram"></i>-->
<!--          <p class="d-lg-none d-xl-none">Instagram</p>-->
<!--        </a>-->
<!--      </li>-->
<!--    </template>-->
<!--  </navbar>-->
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
